import type { FaireCollectionEntity } from "../../entity_types/collection";

export const pbc_7842urt5n6: FaireCollectionEntity = {
  token: "pbc_7842urt5n6",
  type: "collection",
  name: "watercolor workbooks",
  heroImageUrl:
    "https://cdn.faire.com/fastly/e0f33ad099a59af15580107e6cc45e241fd12e7607e70778071c3185903486e1.jpeg",
  itemCount: 21,
  brandToken: "b_mmdanrh9jf",
  productTokens: [],
  meta: {
    source: "api",
    importedAt: "2026-08-14T07:09:21.094Z",
    importedBy: "entity-db-import-collections",
  },
};
